module.exports = __webpack_public_path__ + "img/RDTutorial.0615cfc0.png";